 
export interface SalesOrderPeriodState {
  salesOrderPeriods?: SalesOrderPeriod[];
  pastSalesOrderPeriods?: SalesOrderPeriod[];
}

export enum TreatmentType {
  GBM = 'GBM',
  Fertilization = 'Fertilization',
}

export interface SalesOrderPeriod {
  id: number;
  year: number;
  periodNumber: number;
  name: string;
  startDispatchFrom: string | Date;
  deliverBefore: string | Date;
  periodType: TreatmentType;
}
